import { Controller } from "@hotwired/stimulus";
import React from "react";
import { createRoot } from "react-dom/client";
import { StandaloneTranslationDropDown } from "components/shared/TranslationDropDown";
import * as Turbo from "@hotwired/turbo";

// Connects to data-controller="shared--translation-dropdown"
export default class extends Controller {
  static values = {
    lang: String,
    url: String,
  };

  connect() {
    const props = {
      handleLanguageSelect: this.handleLanguageSelect,
      object_language: this.langValue,
    };

    this.root = createRoot(this.element);
    this.root.render(<StandaloneTranslationDropDown {...props} />);
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
    }
  }

  handleLanguageSelect = (event, language) => {
    event.preventDefault();
    const newUrl = this.urlValue.replace(":locale", language.toLowerCase());
    Turbo.visit(newUrl);
  };
}
